import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }

  /**
   * Tranform pipe method.
   * @param value - date
   * @param pattern - date pattern
   */
  transform(value: string | number | Date, pattern: string = 'mediumDate', timezone: string = null): string {
    return formatDate(value, pattern, this.translateService.currentLang, timezone);
  }
}
